<template>
  <step :number="3" :active="active">
    <template v-slot:head>
      {{ i18n.step_3 }}
    </template>

    <template v-slot:content>
      <div
        v-if="active && activeBoxSpecification"
        class="pt-3 px-3 pt-md-4 px-md-4"
      >
        <div class="row">
          <div class="col-md-4 col-lg-3 mb-3 mb-md-4" v-if="activeBoxSpecification.type">
            <select-input
              id="type"
              :options="activeBoxSpecification.type"
              :label="i18n.label_quality"
              :value="formInput.type"
              modal-identifier="quality"
              @change="onTypeChange"
            />
          </div>

          <div class="col-md-4 col-lg-3 mb-3 mb-md-4" v-if="activeBoxSpecification.color">
            <select-input
              id="color"
              :options="activeBoxSpecification.color"
              :label="i18n.label_color"
              :value="formInput.color"
              modal-identifier="color"
              @change="onColorsChange"
            />
          </div>

          <div class="col-md-4 col-lg-3 mb-3 mb-md-4" v-if="activeBoxSpecification.handles">
            <select-input
              id="handles"
              :options="activeBoxSpecification.handles"
              :label="i18n.label_handles"
              :value="formInput.handles"
              modal-identifier="handles"
              @change="onHandleChange"
            />
          </div>

          <div class="col-md-4 col-lg-3 mb-3 mb-md-4" v-if="activeBoxSpecification.print">
            <select-input
              id="print"
              :options="activeBoxSpecification.print"
              :label="i18n.label_print"
              :value="formInput.print"
              modal-identifier="print"
              @change="onPrintChange"
            />
          </div>
        </div>
      </div>
    </template>
  </step>
</template>

<script>
import { mapGetters } from 'vuex';
import Step from './Step';
import DimensionInput from './fields/DimensionInput';
import SelectInput from './fields/SelectInput';

export default {
  components: {
    SelectInput,
    DimensionInput,
    Step,
  },

  props: {
    active: Boolean,
  },

  computed: {
    ...mapGetters([
      'activeBoxSpecification',
      'formInput',
    ]),
  },

  methods: {
    onTypeChange(event) {
      this.$store.commit('setFormInput', ['type', event.currentTarget.value]);
    },

    onHandleChange(event) {
      this.$store.commit('setFormInput', ['handles', event.currentTarget.value]);
    },

    onColorsChange(event) {
      this.$store.commit('setFormInput', ['color', event.currentTarget.value]);
    },

    onPrintChange(event) {
      this.$store.commit('setFormInput', ['print', event.currentTarget.value]);
    },
  },
};
</script>
